import React, { Component } from 'react';
import ReactDOM from 'react-dom';

import ReportService from '../../service/report-service';
import ActivityService from '../../service/activity-service'

import PrintJs from 'print-js';
import FileSaver from 'file-saver';

import { Spinner } from 'react-bootstrap';
import { ModalAlert } from '../template/modal-alert';

export default class GetPdf extends Component {

    constructor(props) {
        super(props);
        this.state = {
            printing: false
        };
        this.handlePrint = this.handlePrint.bind(this);
    }

    handlePrint(reportType, language) {
        let self = this;
        self.setState({
            printing: true,
        })
        ReportService.getPermReportPdf(this.props.hash, this.props.linkId, this.props.documentName, this.props.reportType, language).then(response => {

            var binaryString = window.atob(response.data.pdf);
            var binaryLen = binaryString.length;
            var bytes = new Uint8Array(binaryLen);
            for (var i = 0; i < binaryLen; i++) {
                var ascii = binaryString.charCodeAt(i);
                bytes[i] = ascii;
            }
            var newBlob = new Blob([bytes], { type: 'application/pdf' });
            var fileURL = URL.createObjectURL(newBlob);

            console.log(fileURL);

            const isIE = /*@cc_on!@*/false || !!document.documentMode;
            const isEdge = !isIE && !!window.StyleMedia;
            var isFirefox = typeof InstallTrigger !== 'undefined';

            if (isIE || isEdge) {
                window.navigator.msSaveOrOpenBlob(newBlob, response.data.reportName);
            } else if (isFirefox) {
                FileSaver.saveAs(newBlob, response.data.reportName);
            } else {
                PrintJs(fileURL);
            }

            self.setState({
                printing: false
            });


        }).catch(error => {
            ModalAlert(error.response.data.error.errorMsg, i18n.t("modal:greska"), i18n.t("modal:zatvori"));
            self.setState({
                downloading: false
            });
        });

        //Activity record
        if (reportType != null) {
            var simpleReport = 0;
            var detailedReport = 0;
            var diagnosticReport = 0;
            if (reportType == 0) {
                simpleReport = 1;
            } else if (reportType == 1) {
                detailedReport = 1;
            } else {
                diagnosticReport = 1;
            }

            ActivityService.recordActivity(0, 0, 0, 1, simpleReport, detailedReport, diagnosticReport, this.props.linkId).then(response => {
            }).catch(error => {
                ModalAlert(error.response.data.error.errorMsg, i18n.t("modal:greska"), i18n.t("modal:zatvori"));
            });
        }
    }

    render() {
        return (
            <React.Fragment>
                {this.state.printing ?
                    <Spinner animation="border" role="status">
                        <span className="sr-only">Loading...</span>
                    </Spinner>
                    :
                    <span style={{ "cursor": "pointer" }} >
                        <i className="material-icons align-middle" aria-hidden="true">print</i>
                    </span>
                }
            </React.Fragment>
        )
    }
}